import React from 'react';
import Loader from 'react-loader-spinner';

export default function AppLoader() {
    return (
        <div className="app-loader">
            <Loader
                color="#2196f3"
                type="ThreeDots"
            />
        </div>
    );
}
